import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

export default store => ({
  path: "bin",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-bin" */ "./components/Bin"),
      import(/* webpackChunkName: "admin-bin" */ "./modules/BinModule"),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, { key: "bin", reducer });
      return component;
    })
  ),
});
